module.exports = __webpack_public_path__ + "static/media/denied_state.d9951572.png";